export default __webpack_public_path__ + "80594b947b94d344686746193096aada.svg";